export default {"src":"/_next/static/media/photography_courses.05a08beb.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};